import { Stepper as MantineStepper, StepperProps } from '@mantine/core';

export type IStepperProps = StepperProps;

/** @registry Design-layer pass-through over Mantine Stepper; import this instead of @mantine/core Stepper outside src/design. Extend here when Stepper needs house behavior. Compound statics (Stepper.Step, Stepper.Completed) are preserved. */
export const Stepper = MantineStepper;
